import narrationFile from '../../content/places/arenal/narration.json'

/**
 * The elder's voice, shared by the rendered world and companion mode so quests
 * are handed over by the same person on both surfaces.
 */

export interface Speaker {
  id: string
  name: string
  role: string
  fictional: boolean
  bio: string
}

export interface Greeting {
  id: string
  title: string
  pages: string[]
}

interface Narration {
  placeId: string
  voice: string
  speaker: Speaker
  greeting: Greeting
  questIntros: Record<string, string>
  questDeferrals: Record<string, string>
  arrivals: Record<string, string>
  photoPrompt: string
  reviewNotice: string
}

const narration = narrationFile as Narration

export function speaker(): Speaker {
  return narration.speaker
}

export function greeting(): Greeting {
  return narration.greeting
}

export function questIntro(questId: string): string | undefined {
  return narration.questIntros[questId]
}

export function questDeferral(questId: string): string | undefined {
  return narration.questDeferrals[questId]
}

/** What the elder says on arriving somewhere. Absent for most entries. */
export function arrivalLine(id: string): string | undefined {
  return narration.arrivals[id]
}

export function photoPrompt(): string {
  return narration.photoPrompt
}

export function reviewNotice(): string {
  return narration.reviewNotice
}
